import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Symbol from 'core/components/Symbol'
import Items from './components/Items'

import RenderAt from '../RenderAt'
import SocialIcons from './components/SocialIcons'
import {Wrapper} from './components/Styled'

const _DEFAULT_LABEL = 'BACK TO HOME'
const _DEFAULT_HREF = '/'

class SecondaryHeader extends PureComponent {
  /*
    --- OPTIONS ---
    whiteBreadcrumbs: Change breadcrumbs to white text and background transparent.
    hideBreadcrumbs: Hide breadcrumbs in desktop.
    hideSocialIcons: Hide social icons in desktop.
    items: Items to render in left breadcrumb in Desktop.
  */

  static defaultProps = {
    items: [
      {
        text: 'Home',
        isLink: true,
        isActive: true,
        props: {
          href: '/'
        }
      }
    ],
    hideBreadcrumbs: false,
    hideSocialBar: false,
    whiteBreadcrumbs: false,
    backToHref: _DEFAULT_HREF,
    backToLabel: _DEFAULT_LABEL,
    showInMobile: true,
    showInDesktop: true,
    background: ''
  }

  static propTypes = {
    background: PropTypes.string,
    backToHref: PropTypes.string,
    backToLabel: PropTypes.string,
    hideBreadcrumbs: PropTypes.bool,
    hideSocialBar: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    showInDesktop: PropTypes.bool,
    showInMobile: PropTypes.bool,
    socialData: PropTypes.object,
    whiteBreadcrumbs: PropTypes.bool
  }

  constructor (props) {
    super(props)

    this.backToLabel = this.props.backToLabel
    this.backToHref = this.props.backToHref

    // if (!this.props.backToHome) {
    if (this.props.backToLabel !== _DEFAULT_LABEL) {
      this.backToLabel = this.props.backToLabel
      this.backToHref = this.props.backToHref
    } else {
      for (let i = this.props.items.length - 1; i >= 0; i--) {
        let item = this.props.items[i]
        if (item.isLink) {
          this.backToLabel = 'BACK TO ' + item.text.toUpperCase()
          this.backToHref = item.props.href
          break
        }
      }
    }
    // }
  }

  renderBreadcrumbs () {
    if (!this.props.hideBreadcrumbs) {
      return <Items items={this.props.items} />
    }
  }

  renderSocialIcons () {
    if (!this.props.hideSocialBar) {
      return <SocialIcons socialData={this.props.socialData} />
    }
  }

  render () {
    return (
      <Wrapper background={this.props.background} whiteBreadcrumbs={this.props.whiteBreadcrumbs}>
        {this.props.showInDesktop && (
          <RenderAt desktop fragment laptop>
            <div className={classNames(
              'secondary-header',
              {'mp-breadcrumbs-blue-to-white': this.props.whiteBreadcrumbs}
            )}>
              <div className='breadcrumbs-row'>
                <div className='breadcrumbs-row__breadcrumbs'>
                  {this.renderBreadcrumbs()}
                </div>
                {this.renderSocialIcons()}
              </div>
            </div>
          </RenderAt>
        )}

        {this.props.showInMobile && (
          <RenderAt fragment mobile tablet>
            <div className={classNames({'mp-breadcrumbs-blue-to-white': this.props.whiteBreadcrumbs})}>
              <div className='breadcrumbs-row'>
                <div className='breadcrumbs-row__back-nav'>
                  <div>
                    <span className='breadcrumbs-row__arrow'>
                      <Symbol className='icon icon-arrow-left' name='icon-arrow-left' />
                    </span>
                    <span className='breadcrumbs-row__back-text'
                      style={{marginLeft: '0px', cursor: 'pointer'}}
                      onClick={() => { window.location.replace(this.backToHref) }}>
                      { this.backToLabel }
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </RenderAt>
        )}
      </Wrapper>
    )
  }
}

export default SecondaryHeader
